import script from "./PcBar.vue?vue&type=script&setup=true&lang=js"
export * from "./PcBar.vue?vue&type=script&setup=true&lang=js"

import "./PcBar.vue?vue&type=style&index=0&id=8fcff796&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8fcff796"]])

export default __exports__